import React from 'react';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MaskInput from '../../../core/form/MaskInput';
import Button from '../../../core/form/Button';
import { CONTRACT_PRODUCTS, CURRENCY_MASK_OPTIONS, HS_SKU_PRODUCTS_CAN_USE_FREE_AMOUNT } from '../../../core/consts';
import Dialog from '../../../core/layout/Dialog';
import TextInput from '../../../core/form/TextInput';

const CheckoutLinkProductsModal = (props) => {
  const disableFreeAmount = !HS_SKU_PRODUCTS_CAN_USE_FREE_AMOUNT.includes(props.values.hs_sku);

  return (
    <Dialog title="Edit Product" isOpen={props.isModalOpen} onCancel={props.onClose} actions={null} width="35%">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.onSubmit();
        }}
      >
        <Row>
          <Column size={12}>
            <TextInput
              label="Description"
              value={get(props.values, 'description', null)}
              onChange={(value) => props.onChange('description', value)}
              disabled
              errorText={get(props.errors, 'description', '')}
            />
          </Column>
        </Row>
        <Row>
          <Column size={3}>
            <MaskInput
              disabled={
                props.submitting ||
                props.loading ||
                props.disabled ||
                [CONTRACT_PRODUCTS.PLACEMENT_TEST_COMERCIAL, CONTRACT_PRODUCTS.TEACHERS_WEB_PAGE].includes(
                  get(props.values, 'hs_sku', '')
                )
              }
              label="Amount"
              value={get(props.values, 'amount', null)}
              onChange={(value) => {
                props.onChange('amount', value);
                props.onChange('amount', value);
              }}
              blocks={[5]}
              numericOnly
            />
          </Column>
          <Column size={3}>
            <MaskInput
              disabled={props.submitting || props.loading || props.disabled || disableFreeAmount}
              label="Free Amount"
              value={get(props.values, 'freeAmount', null)}
              onChange={(value) => props.onChange('freeAmount', value)}
              blocks={[5]}
              numericOnly
            />
          </Column>
          <Column size={3}>
            <MaskInput
              disabled={
                props.submitting ||
                props.loading ||
                get(props.values, 'hs_sku', '') === CONTRACT_PRODUCTS.CUSTOM_PACKAGE
              }
              label="Unit Price"
              required
              value={get(props.values, 'unitPrice', null)}
              onChange={(value) => props.onChange('unitPrice', value)}
              errorText={get(props.errors, 'unitPrice', '')}
              delimiter={CURRENCY_MASK_OPTIONS.real.delimiter}
              numeralDecimalMark={CURRENCY_MASK_OPTIONS.real.numeralDecimalMark}
              maskType="numeral"
            />
          </Column>
          {get(props.values, 'hs_sku', '') === CONTRACT_PRODUCTS.CUSTOM_PACKAGE && (
            <Column size={3}>
              <MaskInput
                disabled={props.submitting || props.loading}
                label="Discount (%)"
                required
                value={get(props.values, 'discount', null)}
                onChange={(value) => props.onChange('discount', value)}
                errorText={get(props.errors, 'discount', '')}
                numeralDecimalMark=","
                delimiter=""
                numeralDecimalScale={4}
                numeralPositiveOnly
                maskType="numeral"
              />
            </Column>
          )}
        </Row>
        <Row>
          <div
            style={{
              textAlign: 'right',
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
              gap: '16px',
            }}
          >
            <Button icon="reload" disabled={props.isDisabled} onClick={props.onReset} label="Discard changes" />
            <Button
              label="Update Product"
              icon="check"
              type="primary"
              disabled={props.isDisabled}
              loading={props.isSubmitting}
              onClick={props.onSubmit}
            />
          </div>
        </Row>
      </form>
    </Dialog>
  );
};

CheckoutLinkProductsModal.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      hs_sku: PropTypes.string,
      name: PropTypes.string,
      price: PropTypes.number,
    })
  ),
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  isModalOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
  hideCoreProducts: PropTypes.bool,
};

CheckoutLinkProductsModal.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  loading: false,
  currencyType: 'real',
  isEditing: false,
  hideCoreProducts: false,
};

export default CheckoutLinkProductsModal;
